konnyScript(function($){
    
    $('.withBoxWrap .withBox .withImg').click(function(){
        $(this).parents('.withBox').addClass('none');
        $(this).parents('.withBox').children('.withIcon').removeClass('on');
    })
    $('.withWrap .withIcon .plus').click(function(){
        $(this).parents('.withIcon').toggleClass('on');
    })
    
    
    setTimeout(function(){
        $('.withBoxWrap .withBox').each(function(){
            var winHeight = $(window).height() * 1/3;
    		var winTop = $(window).scrollTop();
        	var withOff = $(this).offset();
            var withTop = withOff.top - winHeight;
            var withHeight = $(this).height() / 2;
            
            var withBt = withTop + withHeight;
            
            if( withTop <= winTop){
            	if(winTop < withBt){
                    $(this).addClass('active');
                }else{
                }
            }
        });
    }, 1000);
    
    
    $(window).scroll(function(){
        $('.withBoxWrap .withBox').each(function(){
            var winHeight = $(window).height() * 1/3;
            var winTop = $(window).scrollTop();
            var withOff = $(this).offset();
            var withTop = withOff.top - winHeight;
            var withHeight = $(this).height() / 2;
            
            var withBt = withTop + withHeight;
            
            if( withTop <= winTop){
                if(winTop < withBt){
                    if($(this).hasClass('active')){
                    
                    }else{
                        $(this).addClass('active');
                    }
                }else{
                }
            } 
        });
    });
    
});